import { render, staticRenderFns } from "./contactservice.vue?vue&type=template&id=ae2f25c6&scoped=true&"
import script from "./contactservice.vue?vue&type=script&lang=js&"
export * from "./contactservice.vue?vue&type=script&lang=js&"
import style0 from "./contactservice.vue?vue&type=style&index=0&id=ae2f25c6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f25c6",
  null
  
)

export default component.exports